import PaymentCategoryInterface from "@/interface/business/paymentCategory.interface";
import { CategoryType } from "@/types/business/category.type";

export default class PaymentCategory implements PaymentCategoryInterface {
  id: string = "";
  name: string = "";
  type: string = "";
  locations: Array<any> = [];

  constructor(data: CategoryType) {
    Object.assign(this, data);
  }
}
